import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { MuseumStoreLogo } from './A250MuseumStoreLogo';
export function A250FeaturedCollection() {
  return <section className="py-0" data-id="element-12">
      {/* Full-width A250 Feature Card */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-8" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#002868] via-[#003087] to-[#001845] shadow-2xl" data-id="element-14">
          {/* Decorative stripes */}
          <div className="absolute top-0 right-0 w-1/3 h-full opacity-10" data-id="element-15">
            <div className="absolute inset-0 bg-[repeating-linear-gradient(45deg,transparent,transparent_20px,rgba(255,255,255,0.1)_20px,rgba(255,255,255,0.1)_40px)]" data-id="element-16"></div>
          </div>
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-[#BF0A30] rounded-full blur-[100px] opacity-30" data-id="element-17"></div>

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 p-8 lg:p-16" data-id="element-18">
            {/* Left: Content */}
            <div className="flex flex-col justify-center" data-id="element-19">
              <div className="mb-8" data-id="element-20">
                <MuseumStoreLogo size="large" loading="eager" className="h-24 lg:h-32" data-id="element-21" />
              </div>

              <h2 className="text-3xl lg:text-4xl font-serif font-bold text-white mb-4 leading-tight" data-id="element-22">
                Officially licensed products from the America250™ Collection
              </h2>

              <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-23">
                Our best-selling products in a variety of patriotic designs.
                Celebrate America's 250th anniversary with exclusive custom
                merchandise for your institution.
              </p>

              <div className="flex flex-wrap gap-4" data-id="element-24">
                <a href="#" className="inline-flex items-center bg-white text-[#002868] px-6 py-3 rounded-full text-sm font-semibold hover:bg-gray-100 transition-colors group" data-id="element-25">
                  Shop A250 Collection
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-26" />
                </a>
                <a href="#" className="inline-flex items-center text-white border border-white/30 px-6 py-3 rounded-full text-sm font-semibold hover:bg-white/10 transition-colors" data-id="element-27">
                  Learn More
                </a>
              </div>
            </div>

            {/* Right: Product Images */}
            <div className="relative flex items-center justify-center" data-id="element-28">
              <div className="grid grid-cols-2 gap-4" data-id="element-29">
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.2
              }} className="rounded-2xl overflow-hidden shadow-2xl" data-id="element-30">
                  <img src="https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop" alt="Patriotic ceramic products" className="w-full h-40 lg:h-48 object-cover" data-id="element-31" />
                </motion.div>
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.3
              }} className="rounded-2xl overflow-hidden shadow-2xl mt-8" data-id="element-32">
                  <img src="https://images.unsplash.com/photo-1544816155-12df9643f363?w=400&h=300&fit=crop" alt="Premium journals" className="w-full h-40 lg:h-48 object-cover" data-id="element-33" />
                </motion.div>
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.4
              }} className="rounded-2xl overflow-hidden shadow-2xl -mt-4" data-id="element-34">
                  <img src="https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?w=400&h=300&fit=crop" alt="Custom mugs" className="w-full h-40 lg:h-48 object-cover" data-id="element-35" />
                </motion.div>
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.5
              }} className="rounded-2xl overflow-hidden shadow-2xl mt-4" data-id="element-36">
                  <img src="https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=400&h=300&fit=crop" alt="Art prints" className="w-full h-40 lg:h-48 object-cover" data-id="element-37" />
                </motion.div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}